module.exports = __webpack_public_path__ + "static/img/Dyson-Daniels.d1ef727.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dyson-Daniels.jpg
// module id = ceHR
// module chunks = 1